import type { CheckinConfigResponse, UpdateCheckinConfigRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getLocationCheckinConfig(locationId: string): Promise<CheckinConfigResponse> {
  return request<CheckinConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/checkin-config`,
    { method: 'GET' },
  );
}

export async function updateLocationCheckinConfig(
  locationId: string,
  input: UpdateCheckinConfigRequest,
): Promise<CheckinConfigResponse> {
  return request<CheckinConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/checkin-config`,
    { method: 'PUT', body: input },
  );
}
